/* eslint-disable no-unused-vars */
import Layout from 'components/common/Layout';
import { Routes, Route } from 'react-router-dom';
import Login from 'views/Login';
import { useDispatch, useSelector } from 'react-redux';
import ViewsLayout from 'views/ViewsLayout';
import { UserLogin1 } from 'views/Login.user';
import { Suspense, useEffect, useLayoutEffect } from 'react';
import { Loader } from 'components';
import { authActions, ssoLogin } from 'store/auth/auth';
import { EmailValidatePage } from 'views';
import { getIsLocalHost, redirectToOldPlatformLoginUrl, isAiAssistantEnabled } from 'utils';
import { ChatWidgetHost } from 'components/chatWidget/ChatWidgetHost';
import { isAdminSelector, isChatWidgetAvailableSelector } from 'store/selectors';

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   console.log({ value, parts });
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }

function getCookie1(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`;`).filter(Boolean);
  let currentCookie;
  parts.forEach((part) => {
    if (part.includes(name)) {
      const value = part.split('=')[1];
      if (value) {
        currentCookie = value;
      }
    }
  });
  //console.log({ parts, currentCookie });
  return currentCookie;
}

export function AppOldLogin() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isSsoLoading = useSelector((state) => state.auth.isSsoLoading);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const refreshToken = useSelector((state) => state.auth.refreshToken);
  const isAdmin = useSelector(isAdminSelector);
  const isWidgetAvailable = useSelector(isChatWidgetAvailableSelector);

  const dispatch = useDispatch();

  // console.log('before', { isSsoLoading, isLoggedIn });

  // if (!isLoggedIn) {
  //   let uid = getCookie1('adminLoginCookie');
  //   //uid = '0004f089-8f4b-11ed-b12a-1249e5ec4f79';
  //   console.log({ uid });
  //   if (uid && !isSsoLoading) {
  //     console.log({ uid, isSsoLoading });
  //     dispatch(authActions.setIsSsoLoading(true));
  //     dispatch(ssoLogin({ uid }));
  //   }
  // }

  useLayoutEffect(() => {
    let uid = getCookie1('adminLoginCookie');
    console.log({ isSsoLoading, uid, accessToken, refreshToken });
    if (!uid && !getIsLocalHost()) {
      dispatch(authActions.setIsLoggedInToFalse());
      const newUrl = redirectToOldPlatformLoginUrl(`/login2.aspx`);
      console.log('redirection to: ', newUrl);
      window.location.href = newUrl;
    }
    if (uid && !isSsoLoading) {
      console.log({ uid, isSsoLoading });
      dispatch(authActions.setIsSsoLoading(true));
      dispatch(ssoLogin({ uid }));
      return;
    }
    if (uid && isSsoLoading && (!accessToken || !refreshToken)) {
      console.log({ isSsoLoading, uid, accessToken, refreshToken });
      dispatch(authActions.setIsSsoLoading(true));
      dispatch(ssoLogin({ uid }));
      return;
    }
  }, []);

  return (
    <div className='App'>
      {isLoggedIn && isAiAssistantEnabled(isAdmin, isWidgetAvailable) && <ChatWidgetHost />}
      {isSsoLoading && <Loader.Global />}
      {!isSsoLoading && (
        <Layout
          main={
            <Routes>
              {!isLoggedIn && <Route path='*' element={<Login />} />}
              {!isLoggedIn && <Route path='/email-validate' element={<EmailValidatePage />} />}
              {!isLoggedIn && <Route path='/account/login' element={<UserLogin1 />} />}
              {isLoggedIn && (
                <Route
                  path='/*'
                  element={
                    <Suspense fallback={<Loader.Global delay={1} />}>
                      <ViewsLayout />
                    </Suspense>
                  }
                />
              )}
              {/* <Route
                path='*'
                element={
                  <main style={{ padding: '1rem' }}>
                    <p>There&apos;s nothing here!</p>
                  </main>
                }
              /> */}
            </Routes>
          }
        />
      )}
    </div>
  );
}
